import { create } from 'zustand';

// The passive monitor's latest raw readings (use-network-quality), for the
// developer network panel only. The patient-facing UI reads just the verdict
// from the hook itself; nothing on the exercise page subscribes here, so
// writing on every probe re-renders nothing but the panel.
export const useNetworkQualityReadings = create(set => ({
  state: null,
  latencyMs: null,
  latencyMedianMs: null,
  downlinkMbps: null,
  browserDownlinkMbps: null,
  measuredAt: null,
  record: readings => set({ ...readings, measuredAt: Date.now() }),
}));
